<template lang="pug">
  app-layout
    v-snackbar(v-model="getContactRelationshipError" color="error")
      div One or more contacts could not be related, please try again.
    v-snackbar(:value="successMessage" color="success")
      div {{ successMessage }}
    v-snackbar(:value="startCampaignSuccess" color="success")
      div {{ startCampaignSuccess }}
    v-snackbar(:value="startCampaignError" color="error")
      div {{ startCampaignError }}
    v-snackbar(:value="deleteContactError" color="error")
      div {{ deleteContactError }}
    v-snackbar(:value="contactInformationError" color="error")
      div {{ contactInformationError }}
    v-snackbar(:value="findContactError" color="error")
      div {{ findContactError }}
    v-snackbar(v-model="getBulkUpdateContactError" color="error")
      div {{ bulkUpdateContactErrorMessage }}
    v-snackbar(v-model="saveContactSuccess" color="success")
      div Contact saved successfully
    v-snackbar(v-model="getRelationshipSuccess" color="success")
      div Contact Relationship Successfully Removed.
    v-snackbar(v-model="getRelationshipError" color="error")
      div {{ relDeleteErrorMessage }}
      v-btn.contact-information__undo(color="white" flat @click="revertPatch") Undo
    v-snackbar(:value="eventsError" color="error")
      div {{ eventsErrorMessage }}
    v-snackbar(:value="commentsError" color="error")
      div {{ commentsErrorMessage }}
    v-snackbar(v-model="eventPinnedWasToggled" v-show="!eventsError" color="success") {{ eventsSuccessMessage }}
    v-snackbar(v-model="eventIsRemoved" color="success") {{ eventRemovedMessage }}
      v-btn(flat @click="undoEventRemove(lastEventIdRemoved)") Undo
    v-snackbar(v-model="getCmaError" color="error")
      div {{ cmaMessage }}
    v-snackbar(v-model="showTemplateSuccessMessage" color="success")
      div {{ templatesSuccessMessage }}
    v-snackbar(v-model="showTemplateErrorMessage" color="error")
      div {{ templatesErrorMessage }}
    v-snackbar(v-model="showSubmitConsentSuccessMessage" color="success")
      div Consent saved successfully
    liondesk-dialog(
      :value="clearConfirmationDialog"
      dialog-title="Clear All Fields"
      dialog-body="Are you sure you want to clear all fields?"
      ok-button-text="Yes"
      cancel-button-text="No"
      @click:cancel="closeClearConfirmationDialog"
      @click:ok="clearAll"
    )
    sms-compliance-blocked-dialog(
      :value="showSmsComplianceBlockedDialog"
      @close="showSmsComplianceBlockedDialog = false"
    )
    v-dialog.my-4(
      v-if="canEdit('custom field') && customFieldDialog"
      v-model="customFieldDialog"
      persistent
      width="25%"
    )
      v-card
        title-bar(dark) Add Custom Field
        v-card-text
          v-select(
            label="Select type of data"
            :items="customFieldTypes"
            v-model="newCustomField.data_type"
          )
          v-text-field(label="Custom field name" v-model="newCustomField.name")
        v-card-actions
          v-spacer
          v-btn(flat color="primary" @click="closeCustomFieldDialog") Cancel
          v-btn.primary(@click="addCustomField") Save
    liondesk-dialog(
      dialog-title="Calling contact"
      :value="isCallingContact"
      :hideCancelButton="true"
      @click:ok="setIsCallingContact(false)"
    )
      template(slot="body")
        span LionDesk is now calling you.
        |
        | Please press 1 when picking up to be connected to your contact.
    custom-number-dialog(
      v-if="showSelectCustomNumberDialog"
      :value="showSelectCustomNumberDialog"
      @close="showSelectCustomNumberDialog = false"
    )
    register-brand-modal(
      v-if="showRegisterBrandModal"
      :value="showRegisterBrandModal"
      :no-skip="true"
      :new-version="true"
      @close="onCloseRegisterBrandModal"
    )
    email-status-modal(
      v-if="openEmailStatusModal"
      :value="openEmailStatusModal"
      @close="openEmailStatusModal = false"
    )
    slide-drawer(v-if="smsDrawerRendered" ref="slide-drawer" v-model="showSlideDrawer")
      template(slot="title") Send a text
      template(slot="content")
        contact-chat(
          ref="chatContact"
          :contactId="selectedTextContactId"
          :reset-chat="resetChat"
          @reset-completed="resetChat = false"
        )
        text-sending-options(
          padding="pt-0"
          :sending-option-dialog-out="sendingTextOptionsDialog"
          :showSend="false"
          @close-sending-dialog="sendingTextOptionsDialog = false"
          @click:send="clearAll"
          @send-message-callback="sendMessage"
          @change-sending-options="changeSendingOption"
        )
      template(slot="actions")
        v-btn.primary.ld-gated-feature(
          v-if="gatedAction === gatedActions.ComplianceViolationBlocked"
          slot="activator"
          :disabled="isSendButtonDisabled"
          @click="showSmsComplianceBlockedDialog = true"
        ) Send
        v-btn.primary(
          v-else-if="gatedAction === gatedActions.NoAction"
          :disabled="isSendButtonDisabled"
          @click="onSendClick"
        ) Send
        v-btn.primary.ld-gated-feature(
          v-else-if="gatedAction === gatedActions.SetCustomNumber"
          slot="activator"
          :disabled="isSendButtonDisabled"
          @click="showSelectCustomNumberDialog = true"
        ) Send
        v-btn.primary(
          v-else-if="gatedAction === gatedActions.Register10DLC && shouldSendLeadsPlus"
          slot="activator"
          :disabled="isSendButtonDisabled"
          @click="onPending10DLCSend()"
        ) Send
        v-btn.primary.ld-gated-feature(
          v-else-if="gatedAction === gatedActions.Register10DLC"
          slot="activator"
          :disabled="isSendButtonDisabled"
          @click="onPending10DLCSend()"
        ) Send
        v-btn.primary.ld-gated-feature(
          v-else-if="gatedAction === gatedActions.Blocked"
          slot="activator"
          :disabled="true"
        ) Send
      template(slot="body")
        span LionDesk is now calling you.
        |
        | Please press 1 when picking up to be connected to your contact.
    slide-drawer.slide-drawer(
      v-if="emailDrawerRendered"
      ref="email-slide-drawer"
      v-model="showEmailSlideDrawer"
      :confirm-dismiss="showDismissDialog"
      @input="confirmDrawerClose"
    )
      template(slot="title") Send an email
      template(slot="content")
        email-from(v-if="showEmailSlideDrawer && showFromEmailField" withMargin="true")
        email-recipients(
          v-if="showEmailSlideDrawer"
          @reset-confirm-recipient-clear="resetConfirmRecipientClear"
          :confirm-recipient-clear="confirmRecipientClear"
          :clear-on-destroy="!redirectToFullScreen"
          hide-additional-fields
          @input-is-added="changeEmailBoxSize"
        )
        email-subject-body(
          ref="emailSubjectBody"
          :confirm-subject-clear="confirmSubjectClear"
          :activator-style="activatorStyle"
          :liondesk-content-height="EmailBoxSize"
          :default-values="emailTemplateToLoad"
          show-email-options
          container-height="50"
          @reset-confirm-subject-clear="resetConfirmSubjectClear"
          @show-template-picker="showTemplatePicker"
          @clear-all="openClearConfirmationDialog"
        )
        email-schedule-options.justify-end(
          :sending-option-dialog-out="sendingOptionsDialog"
          :showSend="false"
          :sending-option-dialog="sendingOptionsDialog"
          input-size="xs6"
          @close-sending-dialog="sendingOptionsDialog = false"
          @change-sending-options="changeSendingOption"
          @change-recurrence-rule-valid="changeRecurrenceRuleValid"
          @email-sent="clearAll"
        )
        recommend-email-sync(slide-drawer)
      template(slot="actionsCustom")
        .slider-actions.justify-space-between
          .align-self-center.ml-1
            v-btn(flat color="primary" @click="openEmailFullScreen") Fullscreen
              v-icon.accent--text.ml-1.icon-align fullscreen
          .justify-end
            v-flex(d-flex)
              .align-self-center
                v-btn(flat color="primary" @click="closeSlideDrawer(true, 'email-slide-drawer')") Cancel
              email-sending-options(
                :sendOptionRadioValue="sendOptionRadioValue"
                :recurrenceRuleValid="recurrenceRuleValid"
                @sending-option-dialog="sendingOptionsDialog = true"
              )
    add-event-drawer(
      :add-events="bulkCreateEvents"
      :selected-ids="contactIds"
      :show-contact-selection="false"
      @contact-updated="onContactUpdated"
      :update-event="updateEvent"
      :validateDescription="validateDescription"
      data-cy="event-drawer"
      ref="eventDrawer"
      :isComment="isComment"
      @setIsComment="setIsComment"
      :edit="eventToEdit"
    )
    save-contact-sheet(
      :user-has-changes="userHasChanges"
      :unsaved-changes="unsavedChanges"
      :is-form-valid="isFormValid"
      @save-contact="saveContact"
      @cancel-update="cancelUpdate"
    )
    v-layout.fill-page-height(v-if="!userHasAccessToContact" justify-center align-center)
      v-progress-circular(
        indeterminate
        color="primary"
      )
    v-container.pa-0.profileWrapper.profile-container(
      fluid
      fill-height
      v-if="userHasAccessToContact"
    )
      v-layout(row wrap)
        v-flex.leftBoardParent(xs3)
          v-layout(column wrap)
            v-flex(xs12)
              action-card(
                :contacts="contacts"
                :current-contact="contact"
                :last-activity="getLastActivity"
                :selected-tags="selectedTags"
                :tags-list="tags"
                @save-tags="saveTags"
                @find-tags="findTags"
                @create-tag="createTag"
                @set-new-tags="setNewTags"
                @add-to-patched-fields="addToPatchedFields"
                @save-contact="saveContact"
                @contact-updated="refreshPage"
                @showChatDrawer="showContactChat"
                @openEventDrawer="openEventDrawer"
                @openEmailDrawer="openEmailDrawer"
                @resize="innerHeightHasChanged"
                @refresh-events="refreshEvents"
              )
            v-flex(xs12)
              #profileV2SideBoard.board(:style="leftBoardHeight" data-column_position="left")
                favorite-fields(
                  ref="favorite-fields"
                  :contact="contactCopy"
                  :filtered-favorites="filteredFavorites"
                  :fields-for-favorites="fieldsForFavorites"
                  :is-text-field="isTextField"
                  :hotnesses="hotnesses"
                  :hotnessColor="hotnessColour"
                  :labels="labels"
                  :field-value-error-types="fieldValueErrorTypes"
                  :field-value-error-messages="fieldValueErrorMessages"
                  :phone-email-action="phoneEmailAction"
                  :validations="validations"
                  :custom-field-validation="customFieldValidation"
                  @field-status-change="fieldStatusChange"
                  @set-favorites="setFavoriteFields"
                  @input="debounceFields"
                  @showChatDrawer="showContactChat"
                  @openEmailDrawer="openEmailDrawer"
                )
                draggable(@end="saveDraggableCardOrder" :list="leftBoardCards" group="allCards")
                  draggable-card(
                    v-for="card in leftBoardCards"
                    :key="card.card_id"
                    :ref="`section-${card.card_id}`"
                    :cardTitle="card.card_title"
                    :action="card.card_action"
                    :card="card"
                    :field-value-error-types="fieldValueErrorTypes"
                    :field-value-error-messages="fieldValueErrorMessages"
                    @add-custom-field="showAddCustomFieldDialog"
                    @addressAdd="addAddress"
                    @delete="deleteAddress"
                    @input="debounceFields"
                    @field-status-change="fieldStatusChange"
                    @open-email-status-modal="openEmailStatusModal = true"
                    @refresh-optin="getDraggableCards"
                    @show-custom-number-modal="showSelectCustomNumberDialog = true"
                    @click:showmore="loadMoreContactOwnerCustomFields()"
                    @click:showless="showLessContactOwnerCustomFields()"
                    :highligth="shouldHighligthCard(card.card_id)"
                  )

        v-flex(:class="isCollapsed ? 'xs6' : 'expanded'")
          qualify-conversation(
            v-if="isQualifyLeadAndIntegrationConnected"
            @refresh="refreshEvents"
          )
          v-tabs.tabs(
            :key="isCollapsed"
            v-model="selectedTab"
            color="transparent"
            slider-color="orange"
            show-arrows
          )
            v-tab.custom-tab ALL ACTIVITY
            v-tab.custom-tab COMMENTS
            v-tab.custom-tab TASKS
            v-tab.custom-tab CAMPAIGNS
            v-tab.custom-tab INBOX
            v-tab.custom-tab SCHEDULED
            v-spacer

            v-tabs-items(v-model="selectedTab")
              v-tab-item(:value="0")
                v-divider.pb-2

                activity-options.pb-2(
                  :events="eventsData"
                  @type-updated="onTypesChange"
                  @member-updated="onMemberChange"
                  @date-updated="onDateChange"
                )
                  v-btn.white--text(
                    slot="extra-options"
                    color="primaryv2"
                    data-cy="open-event-modal"
                    small
                    @click="openEventDrawer(false)"
                  ) ADD ACTIVITY
                .activity-scroll.centralBoardHeight
                  v-layout(justify-center)
                    v-progress-circular(
                      v-if="eventsInProgress && !eventsData.length"
                      indeterminate
                      color="primary"
                    )
                  template(v-if="eventsData.length")
                    activity-card(
                      v-for="event in eventsData"
                      :activityTypes="activityTypes"
                      :activity="event"
                      :update-event="updateEvent"
                      :validate-description="validateDescription"
                      @edit-event="editEventDrawer"
                      :current-contact="contact"
                      @activity-pinned="toggleEventPin"
                      @activity-deleted="remove"
                      @activity-updated="refreshEvents"
                      @open-email-drawer="openEmailDrawerPreloadCmaTemplate(event)"
                    )
                  span(v-else-if="!eventsInProgress")
                    p.total-activities No data available
                  scroll-observer(@intersecting="getActivities")
                  v-layout(justify-center my-2)
                    v-progress-circular(
                      v-if="eventsInProgress && eventsData.length"
                      indeterminate
                      color="primary"
                      :size="25"
                      :width="3"
                    )

                v-flex.pt-3(xs12 v-if="false")
                  span.total-activities {{ eventsTotal }} Total Activities
              v-tab-item(:value="1" lazy)
                v-divider.pb-2

                activity-options.pb-2(
                  :events="commentsData"
                  @member-updated="onCommentsMemberChange"
                  @date-updated="onCommentsDateChange"
                  hideTypeSelector
                )
                  v-btn.white--text(
                    slot="extra-options"
                    color="primaryv2"
                    data-cy="open-event-drawer"
                    small
                    @click="openEventDrawer"
                  ) ADD COMMENT
                .activity-scroll.centralBoardHeight
                  v-layout(justify-center)
                    v-progress-circular(
                      v-if="commentsInProgress && !commentsData.length"
                      indeterminate
                      color="primary"
                    )
                  template(v-if="commentsData.length")
                    activity-card(
                      v-for="comment in commentsData"
                      :activityTypes="activityTypes"
                      :activity="comment"
                      :update-event="updateEvent"
                      @edit-event="editEventDrawer"
                      :validate-description="validateDescription"
                      :current-contact="contact"
                      @activity-pinned="toggleEventPin"
                      @activity-deleted="remove"
                      @activity-updated="refreshComments"
                      @open-email-drawer="openEmailDrawerPreloadCmaTemplate(comment)"
                      isCommentSection
                    )
                  span(v-else-if="!commentsInProgress")
                    p.total-activities No data available
                  scroll-observer(@intersecting="getComments")
                  v-layout(justify-center my-2)
                    v-progress-circular(
                      v-if="commentsInProgress && commentsData.length"
                      indeterminate
                      color="primary"
                      :size="25"
                      :width="3"
                    )

                v-flex.pt-3(xs12 v-if="false")
                  span.total-activities {{ commentsTotal }} Total Activities
              v-tab-item(:value="2" lazy)
                task-list-v2(
                  :contact-ids="contactIds"
                  :contacts="[contact]"
                  :key="$route.params.id"
                  is-profile-v2
                  data-cy="task-list"
                )
              v-tab-item(:value="3" lazy)
                campaign-communication-list(
                  :contact-ids="contactIds"
                  :key="`comms-${$route.params.id}`"
                  :isProfileV2="true"
                  data-cy="campaign-comms-list"
                )
              v-tab-item.section-scroll(:value="4" lazy)
                email-activity-list(:contact-id="`${$route.params.id}`" :is-profile-v2="true")
              v-tab-item.section-scroll(:value="5" lazy)
                scheduled(
                  :contact-ids="contactIds"
                  :key="`comms-${$route.params.id}`"
                  :isProfileV2="true"
                  data-cy="campaign-comms-list"
                )

        v-flex(:class="isCollapsed ? 'no-collapsed' : 'collapsed'" align-center justify-center xs3)
          v-container.expand-third-row(
            :class="isCollapsed ? 'expand-third-row--collapse' : 'expand-third-row--expand'"
            @click="isCollapsed = !isCollapsed"
          )
            v-layout(align-center justify-start)
              .pr-1.action-icon
                v-icon(color="primary" :class="isCollapsed ? 'right' : 'left'") double_arrow
              .action {{ isCollapsed ? 'Collapse Info' : 'Expand' }}
          div(:class="isCollapsed ? 'd-block' : 'd-none'" data-column_position="right")
            contact-relationships(
              :contactId="contact.id"
              @refresh-relationships="refreshContactsRelationships"
              @showChatDrawer="showContactChat"
              @openEmailDrawer="openEmailDrawer"
            )
            draggable(
              v-if="false"
              @end="saveDraggableCardOrder"
              :list="rightBoardCards"
              group="allCards"
            )
              draggable-card(
                v-for="card in rightBoardCards"
                :key="card.card_id"
                :cardTitle="card.card_title"
                :action="card.card_action"
                :card="card"
                @addressAdd="addAddress"
                @delete="deleteAddress"
                @input="addToPatchedFields"
                @field-status-change="fieldStatusChange"
              )
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import draggable from 'vuedraggable';
import ProfileV2Information from './config/profile-v2-information';
import ActivityCard from './components/profile-v2/ActivityCard';
import ActivityOptions from './components/profile-v2/ActivityOptions';
import ScrollObserver from '@/Core/components/ScrollObserver';
import ActionCard from './components/profile-v2/ActionCard';
import DraggableCard from './components/profile-v2/Components/DraggableCard';
import FavoriteFields from './components/profile-v2/Components/FavoriteFields';
import { PreferenceKeys } from '@/Core/config/preferences';
import profileV2Cards from '@/Contacts/config/profile-v2-cards';
import profileV2AddressFields from '@/Contacts/config/profile-v2-address-fields';
import TextSendingOptions from '@/Text/components/TextSendingOptions';
import { GATED_ACTIONS } from '@/Core/config/gated-actions';
import sendSMSGate from '@/Core/mixins/send-sms-gate';
import ContactRelationships from '@/Contacts/components/profile-v2/ContactRelationships/ContactRelationships';
import QualifyConversation from '@/Contacts/components/profile-v2/QualifyConversation';
import { EmailReport } from '@/Contacts/config/cma';
import { soleProprietor } from '@/Text/config/consoleSteps';

const EmailActivityList = () =>
  import(
    /* webpackChunkName: 'EmailActivityList' */ './components/email-activity/EmailActivityList'
  );
const CampaignCommunicationList = () =>
  import(
    /* webpackChunkName: 'CampaignCommunicationList' */ './components/profile/CampaignCommunicationList'
  );
const TaskListV2 = () =>
  import(/* webpackChunkName: 'TaskListV2' */ '@/Tasks/components/TaskListV2');
const Scheduled = () =>
  import(/* webpackChunkName: 'ScheduledList' */ './components/profile/ScheduledList');
const SlideDrawer = () =>
  import(/* webpackChunkName: 'SlideDrawer' */ '@/Core/components/SlideDrawer');
const EmailRecipients = () =>
  import(/* webpackChunkName: 'EmailRecipients' */ '@/Email/components/EmailRecipients');
const EmailSendingOptions = () =>
  import(/* webpackChunkName: 'EmailSendingOptions' */ '@/Email/components/EmailSendingOptions');
const EmailSubjectBody = () =>
  import(/* webpackChunkName: 'EmailSubjectBody' */ '@/Email/components/EmailSubjectBody');
const EmailScheduleOptions = () =>
  import(/* webpackChunkName: 'EmailScheduleOptions' */ '@/Email/components/EmailScheduleOptions');
const RecommendEmailSync = () =>
  import(/* webpackChunkName: 'RecommendEmailSync' */ '@/Email/components/RecommendEmailSync');
const ContactChat = () =>
  import(/* webpackChunkName: 'ContactChat' */ '@/Core/components/ContactChat');
const LiondeskDialog = () =>
  import(/* webpackChunkName: 'LiondeskDialog' */ '@/Core/components/LiondeskDialog');
const EmailFrom = () => import(/* webpackChunkName: 'EmailFrom' */ '@/Email/components/EmailFrom');
const SaveContactSheet = () =>
  import(
    /* webpackChunkName: 'SaveContactSheet' */ './components/profile-v2/Components/SaveContactSheet'
  );
const AddEventDrawer = () =>
  import(/* webpackChunkName: 'AddEventDrawer' */ '@/Contacts/components/actions/AddEventDrawer');
const TitleBar = () => import(/* webpackChunkName: 'TitleBar' */ '@/Core/components/TitleBar');
const CustomNumberDialog = () =>
  import(/* webpackChunkName: 'CustomNumberDialog' */ '../Core/components/CustomNumberDialog');
const RegisterBrandModal = () =>
  import(/* webpackChunkName: 'RegisterBrandModal' */ '@/Core/components/RegisterBrandModal');
const EmailStatusModal = () =>
  import(/* webpackChunkName: 'EmailStatusModal' */ './components/EmailStatusModal');
const SmsComplianceBlockedDialog = () =>
  import(/* webpackChunkName: 'SmsComplianceBlockedDialog' */ '../Core/components/SmsComplianceBlockedDialog');


import ConfirmLeaveModal from '@/Core/mixins/confirmLeaveModal';
import toggleSlideDrawer from '@/Core/mixins/toggle-slide-drawer';
import ContactInfo from './mixins/ContactInfo';
import { timeBetweenDates } from '@/Contacts/utilities';
import { eventTypes, MAX_DESCRIPTION_LENGTH } from '@/Core/config/events';
import { debounce } from '@/Core/utilities';
import { SEND_OPTIONS } from '@/Communications/config';
import { STATUS, STATUS_CARD } from '@/Contacts/config/profile-optin-status';
import { EMAIL_STATUS_VALUE } from '@/Contacts/config/profile-email-status';
import { REGISTRATION_STATES } from '../Text/config/registrationStatus';
import { EventBus } from '@/event-bus';
import { STEPS_SOLE_PROPRIETOR } from '@/a2p/config';
import { LdFeatures } from 'lion-vue';


const {
  mapActions: mapEventListActions,
  mapState: mapEventListState,
  mapGetters: mapEventListGetters,
} = createNamespacedHelpers('eventList');

const {
  mapActions: mapContactsActions,
  mapState: mapContactState,
  mapMutations: mapContactsMutations,
  mapGetters: mapContactGetters,
} = createNamespacedHelpers('contact');

const { mapState: mapContactsTableState, mapActions: mapContactsTableActions } =
  createNamespacedHelpers('contactsTable');

const { mapActions: mapTeamMembersActions, mapGetters: mapTeamMembersGetters } =
  createNamespacedHelpers('teamMembers');

const { mapActions: mapSubAccountsActions, mapGetters: mapSubAccountGetters } =
  createNamespacedHelpers('subAccounts');

const { mapState: mapCustomFieldsState, mapActions: mapCustomFieldsActions } =
  createNamespacedHelpers('customFields');

const {
  mapState: mapConversationsState,
  mapActions: mapConversationsActions,
  mapGetters: mapConversationsGetters,
} = createNamespacedHelpers('conversations');

const { mapState: mapUserInformationState, mapGetters: mapUserInformationGetters } = createNamespacedHelpers('userInformation');

const { mapActions: mapContactsSearchActions } = createNamespacedHelpers('contactsSearchCampaign');

const { mapState: mapBulkActionsState, mapActions: mapContactsTableBulkActions } =
  createNamespacedHelpers('contactsTable/bulkActions');

const { mapActions: mapRecipientsActions } = createNamespacedHelpers('recipients');

const { mapState: mapCmaState, mapMutations: mapCmaMutations } = createNamespacedHelpers('cma');

const {
  mapActions: mapRelationshipsActions,
  mapState: mapRelationshipsState,
  mapMutations: mapRelationshipsMutations,
} = createNamespacedHelpers('contactRelationships');

const {
  mapActions: mapQualifyActions,
  mapState: mapQualifyState,
  mapGetters: mapQualifyGetters,
} = createNamespacedHelpers('qualify');

const { mapActions: mapTemplatesActions, mapState: mapTemplatesState } =
  createNamespacedHelpers('templates');

const { mapState: mapPaymentState, mapActions: mapPaymentActions } = createNamespacedHelpers('payment');

const {
  mapActions: mapSoleProprietorActions, mapState: mapSoleProprietorState,
} = createNamespacedHelpers('registerSoleProprietorA2p');

const { 
  mapState: mapPreferencesState, mapActions: mapPreferencesActions
} = createNamespacedHelpers('preferences');

const {
  mapActions: mapEmailAccountsActions,
  mapState: mapEmailAccountsState,
} = createNamespacedHelpers('emailAccounts');

const {
  mapState: mapEmailSuppressionsState,
  mapMutations: mapEmailSuppressionsMutations,
  mapActions: mapEmailSuppressionsActions,
} = createNamespacedHelpers('emailSuppressions');

const { 
  mapActions: mapSmsConsentActions,
  mapState: mapSmsConsentState,
  mapMutations: mapSmsConsentMutations,
} = createNamespacedHelpers('smsConsent');

const { mapActions: mapUserSmsErrorRatesActions } = createNamespacedHelpers(
  'userSmsErrorRates',
);

const {
  mapState: mapUserPreferencesState,
} = createNamespacedHelpers('userPreferences');

const LEFT_BOARD = 'left';
const RIGTH_BOARD = 'right';
const CONTACT_OWNER_CFS_CARD = 'contact_owner_custom_fields';
const solePropCloseAction = 'profile-v2';

export default {
  components: {
    ActivityCard,
    ActivityOptions,
    ScrollObserver,
    ActionCard,
    DraggableCard,
    TitleBar,
    SlideDrawer,
    LiondeskDialog,
    ContactChat,
    EmailRecipients,
    EmailSendingOptions,
    EmailSubjectBody,
    EmailScheduleOptions,
    EmailFrom,
    FavoriteFields,
    SaveContactSheet,
    CampaignCommunicationList,
    TaskListV2,
    Scheduled,
    EmailActivityList,
    AddEventDrawer,
    draggable,
    TextSendingOptions,
    CustomNumberDialog,
    RegisterBrandModal,
    ContactRelationships,
    QualifyConversation,
    RecommendEmailSync,
    EmailStatusModal,
    SmsComplianceBlockedDialog,
  },
  mixins: [toggleSlideDrawer, ConfirmLeaveModal, ContactInfo, sendSMSGate],
  data() {
    return {
      userHasAccessToContact: false,
      selectedTab: 0,
      activities: ProfileV2Information.activities,
      activityTypes: ProfileV2Information.activityTypes,
      iconsList: ProfileV2Information.iconsList,
      pinnedActiviesError: false,
      pinnedActiviesErrorMessage:
        'You can only pin 3 items per contact. Unpin an activity to pin a new one.',
      maxCardsToShow: 5,
      selectedActivities: [],
      selectedTextContactId: 0,
      resetChat: false,
      showEmailSlideDrawer: false,
      clearConfirmationDialog: false,
      confirmRecipientClear: false,
      confirmSubjectClear: false,
      EmailBoxSize: 90,
      sendingOptionsDialog: false,
      activatorStyle: 'margin-top: -22px !important',
      redirectToFullScreen: false,
      fieldValueErrorTypes: [],
      patchedParams: {
        addresses: {
          write: [], // array of objects to create/patch
          remove: [], // array of IDs
        },
        custom_fields: [],
      },
      lastPatch: {
        addresses: {
          remove: [],
          write: [],
        },
        custom_fields: [],
        custom_fields_remove: [],
      },
      contactCopy: {},
      initialCustom: [],
      initialAddresses: null,
      initialContact: null,
      userHasChanges: false,
      unsavedChanges: [],
      saveContactSuccess: false,
      favoriteFields: [],
      fieldValueErrorMessages: {},
      isProfileV2: true,
      error: null,
      invalidFields: [],
      isFormValid: true,
      validations: {
        isNumber: value => {
          // allow blank values to pass validation
          if (value) {
            return (
              /^\d*$/.test(value) || 'Please enter an integer (no decimal points) for this field'
            );
          }
          return true;
        },
        isDollar: value => {
          if (value) {
            return (
              /^\d*\.\d{2}$/.test(value) ||
              'Please enter a dollar amount (e.g. 999.00) for this field'
            );
          }
          return true;
        },
      },
      pagination: { sortBy: 'created_at', descending: true, page: 0 },
      commentsPagination: { sortBy: 'created_at', descending: true, page: 0 },
      eventsData: [],
      commentsData: [],
      selectedTypes: eventTypes,
      eventPinnedWasToggled: false,
      eventIsRemoved: false,
      lastEventIdRemoved: null,
      memberId: null,
      dateRange: null,
      commentsMemberId: null,
      commentsDateRange: null,
      draggableCards: [],
      customFieldDialog: false,
      newCustomField: {},
      newCustomFieldId: 0,
      newAddrId: 0,
      cardPreferences: [],
      rightBoardCards: [],
      leftBoardCards: [],
      leftBoardHeight: '',
      debouncingChanges: [],
      sendOptionRadioValue: 1,
      recurrenceRuleValid: false,
      sendingTextOptionsDialog: false,
      showSelectCustomNumberDialog: false,
      showRegisterBrandModal: false,
      gatedActions: GATED_ACTIONS,
      emailTemplateToLoad: {
        subject: '',
        body: '',
      },
      emailDrawerRendered: false,
      smsDrawerRendered: false,
      isComment: false,
      eventToEdit: null,
      openEmailStatusModal: false,
      showSmsComplianceBlockedDialog: false,
    };
  },
  async created() {
    await this.getAllowedNewFlow();
    await this.findContact({ contactId: this.$route.params.id, profileV2: true });
    this.userHasAccessOrRedirect();
    this.getIsUserBlocked();
    this.resetContactOwnerCustomFields();
    this.findSharedUsers(this.$route.params.id);
    this.findCampaigns();
    this.loadContactQualifyStatus(this.$route.params.id);
    this.getIntegrationStatus();
    this.findTags();
    this.initActivities();
    this.setRouteWatcher(this.refreshPage);
    this.findEmailListsByContact(this.$route.params.id);
    await this.findUserPreferences({ key: PreferenceKeys.ContactDraggableCards });
    this.cardPreferences = this[PreferenceKeys.ContactDraggableCards]
    this.getDraggableCards();
    if (this.userHasFeatureFlag('custom-fields-sharing')) {
      this.getContactOwnerCustomFields(this.$route.params.id);
    }
    if(!this.has10dlcRegister || this.isRegistration10dlcIncomplete) {
      this.checkFor10dlcRegister();
    }
    this.fetchContactRelationships(this.$route.params.id);
    this.checkContactOptInStatus(parseInt(this.$route.params.id, 10));
    this.checkLeadsPlusContact(this.$route.params.id);
    EventBus.$on('sole-prop-modal-close', data => {
      if (data === solePropCloseAction && this.canSendSMS) {
        this.onSendClick()
      }
    });
  },
  mounted() {
    this.innerHeightHasChanged();
    window.addEventListener('resize', this.innerHeightHasChanged);
  },
  destroyed() {
    window.removeEventListener('resize', this.innerHeightHasChanged);
  },
  watch: {
    invalidFields(data) {
      this.isFormValid = data.length <= 0;
    },
    contactTypes() {
      this.getDraggableCards();
    },
    contactProfileUnsavedFields(newValue) {
      this.contactProfileUnsavedFields.forEach(field => {
        this.addToPatchedFields({ id: field.id, value: field.value }, 'custom_fields');
      });
    },
    subAccounts(newValue) {
      this.getDraggableCards();
    },
    currentContact: {
      handler(newValue) {
        this.resetContactOwnerCustomFields();
        if (newValue.card_preferences) {
          this.cardPreferences = newValue.card_preferences;
        }
        this.getDraggableCards();
        this.orderDraggableCards();
        if (this.userHasFeatureFlag('custom-fields-sharing')) {
          this.getContactOwnerCustomFields(this.$route.params.id);
        }
        this.$forceUpdate();
      },
      deep: true,
    },
    contactOwnerCustomFields: {
      handler() {
        this.handleContactOwnerCustomFields();
      },
    },
    relationshipsTypeChanges(relationships) {
      this.addToPatchedFields(relationships, 'contacts_relationships');
    },
    addRegisterFeeAddonsSuccess: {
      handler(value) {
        if (!value) { return };
        this.setStep(STEPS_SOLE_PROPRIETOR.STATUS);
        this.setShowRegistrationFlowModal({ bool: true, action: this.registrationModalClose });
        this.setAddRegisterFeeAddonsSuccess(false);
      },
    },
    userHasChanges: {
      handler() {
        this.innerHeightHasChanged();
      },
    },
    contactDraggableCardsOrder: {
      immediate: true,
      deep: true,
      handler(value) {
        this.cardPreferences = value;
        this.orderDraggableCards()
      }
    }
  },

  computed: {
    ...mapSoleProprietorState(['registrationModalClose']),
    ...mapUserPreferencesState([PreferenceKeys.ContactDraggableCards]),
    ...mapUserInformationGetters(['userHasNylasSend', 'shouldGoToLeadsPlusFlow', 'userHasFeatureFlag', 'hasAccessToFeature']),
    ...mapConversationsGetters(['isSendButtonDisabled']),
    ...mapContactGetters({
      currentContact: 'currentContact',
      hotnesses: 'hotnessesWithDefaultItem',
      contactTypes: 'contactTypesWithDefaultItem',
      currentUserInfo: 'currentUserInfo',
      sources: 'sourcesWithDefaultItem',
      shouldShowMoreCustomFields: 'shouldShowMoreCustomFields',
      shouldShowLessCustomFields: 'shouldShowLessCustomFields',
    }),
    ...mapSubAccountGetters(['subAccountsInfo']),
    ...mapContactState([
      'isCallingContact',
      'hasError',
      'statuses',
      'contactInProgress',
      'addressTypes',
      'contactError',
      'currentUser',
      'modalRunningCampaign',
      'emailListsByContact',
      'contactProfileUnsavedFields',
      'tags',
      'findContactError',
      'updateContactError',
      'updateContactErrorCode',
      'contactOwnerCustomFields',
    ]),
    ...mapEventListState([
      'events',
      'eventsError',
      'eventsSuccessMessage',
      'eventsErrorMessage',
      'eventsTotal',
      'eventsPages',
      'eventsInProgress',
      'comments',
      'commentsError',
      'commentsErrorMessage',
      'commentsTotal',
      'commentsInProgress',
    ]),
    ...mapContactsTableState(['contacts']),
    ...mapBulkActionsState([
      'startCampaignSuccess',
      'startCampaignError',
      'deleteContactError',
      'successMessage',
      'bulkUpdateContactErrorMessage',
      'bulkUpdateContactError',
    ]),
    ...mapTeamMembersGetters(['teamMembersInfo']),
    ...mapCustomFieldsState(['customFieldTypes']),
    ...mapEventListGetters(['getLastActivityDate']),
    ...mapConversationsState([
      'has10dlcRegister',
      'contactsOptInStatuses',
      'contactOptInStatus',
      'registrationStatus10dlc',
      'registrationType10dlc',
      'registrationDate10dlc',
      'isLeadsPlusUser',
      'isLeadsPlusContact',
      'isRegistration10dlcIncomplete',
    ]),
    ...mapCmaState({
      cmaMessage: state => state.message,
      cmaHasError: state => state.hasError,
      cmaHasApiKeyError: state => state.hasApiKeyError,
    }),
    ...mapRelationshipsState({
      relsErrors: state => state.relsErrors,
      relIsDeleteSuccess: state => state.isDeleteSuccess,
      relIsDeleteError: state => state.isDeleteError,
      relDeleteErrorMessage: state => state.deleteErrorMessage,
      relationshipsTypeChanges: state => state.relationshipsTypeChanges,
    }),
    ...mapQualifyState(['qualifyContactLead']),
    ...mapQualifyGetters(['isIntegrationConnected']),
    ...mapTemplatesState([
      'templatesSuccess',
      'templatesSuccessMessage',
      'templatesError',
      'templatesErrorMessage',
    ]),
    ...mapPaymentState(['addRegisterFeeAddonsSuccess']),
    ...mapUserInformationState(['user']),
    ...mapPreferencesState({ isCollapsedPreference: state => state.contactProfilePannelIsExpanded }),
    ...mapEmailAccountsState(['allowedNewFlow']),
    ...mapEmailSuppressionsState(['suppressions']),
    ...mapSmsConsentState(['submitSuccess']),
    showFromEmailField() {
      return this.userHasNylasSend || this.allowedNewFlow;
    },
    contactDraggableCardsOrder() {
      return this[PreferenceKeys.ContactDraggableCards]
    },
    isQualifyLeadAndIntegrationConnected() {
      return (
        this.qualifyContactLead && this.qualifyContactLead.id > 0 && this.isIntegrationConnected
      );
    },
    getPinnedActivities() {
      return this.activities.filter(activity => activity.pinned).length;
    },
    contactIds() {
      return [parseInt(this.$route.params.id, 10)];
    },
    showDismissDialog() {
      const isBodyNotEmpty = this.body && this.body != DEFAULT_EMAIL_BODY;
      return Boolean(this.subject || isBodyNotEmpty);
    },
    getLastActivity() {
      if (!this.getLastActivityDate) return;

      const today = new Date();
      const lastEventTime = new Date(this.getLastActivityDate);

      const elapsedTime = timeBetweenDates(today, lastEventTime);
      return `Last Activity ${elapsedTime} ago`;
    },
    eventRemovedMessage() {
      return 'Activity successfully removed';
    },
    getContactRelationshipError: {
      get() {
        return this.relsErrors;
      },
      set(value) {
        this.setRelsErrors(value);
      },
    },
    getBulkUpdateContactError: {
      get() {
        return this.bulkUpdateContactError;
      },
      set() {
        this.resetBulkUpdateContactErrors();
      },
    },
    getCmaError: {
      get() {
        return this.cmaHasError;
      },
      set() {
        this.cmaResetErrorMessage();
      },
    },
    getCmaApiKeyError: {
      get() {
        return this.cmaHasApiKeyError;
      },
      set(value) {
        this.cmaSetApiKeyError(value);
      },
    },
    getRelationshipError: {
      get() {
        return this.relIsDeleteError;
      },
      set() {
        this.relClearDeleteMessages();
      },
    },
    getRelationshipSuccess: {
      get() {
        return this.relIsDeleteSuccess;
      },
      set() {
        this.relClearDeleteMessages();
      },
    },
    showTemplateSuccessMessage: {
      get() {
        return this.templatesSuccess;
      },
      set() {
        this.templatesClearSuccess();
      },
    },
    showTemplateErrorMessage: {
      get() {
        return this.templatesError;
      },
      set() {
        this.templatesClearErrors();
      },
    },
    isCollapsed: {
      get() {
        return this.isCollapsedPreference;
      },
      set(val) {
        this.updatePreference({
          key: 'contactProfilePannelIsExpanded',
          value: val,
        });
      },
    },
    showSubmitConsentSuccessMessage: {
      get() {
        return this.submitSuccess;
      },
      set() {
        this.setSubmitSuccess(false);
      },
    },
    // simplify after Aug 31
    canSendSMS() {
      const limitDate = new Date(2023, 8, 1);
      if (new Date() > limitDate) {
        return this.registrationStatus10dlc === 'campaign_completed';
      }
      const targetDate = new Date(Date.UTC(2023, 6, 20)); // July 20, 2023
      targetDate.setUTCHours(0, 0, 0, 0);
      const userCreatedAt = Date.parse(this.user.created_at);
      return new Date(userCreatedAt) < targetDate;
    },
    shouldSendLeadsPlus() {
      return this.shouldGoToLeadsPlusFlow && this.isLeadsPlusUser && this.isLeadsPlusContact && this.sendOptionRadioValue === SEND_OPTIONS.Immediate;
    },
    userHasTextsAccess() {
      return this.hasAccessToFeature(LdFeatures.TextMessaging);
    },
  },

  methods: {
    ...mapRelationshipsActions([
      'fetchContactRelationships',
      'resetRelationships',
      'resetRelationshipsTypeChanges',
      'setRelsErrors',
    ]),
    ...mapContactsActions([
      'findAddressTypes',
      'loadContactSources',
      'findEmailListsByContact',
      'loadContactTypes',
      'loadContactHotnesses',
      'patchContact',
      'findContact',
      'findTags',
      'findSharedUsers',
      'assignRemovedFromStaticListsHistory',
      'createCustomField',
      'createTag',
      'hideModalRunningCampaign',
      'findCurrentUser',
      'getContactOwnerCustomFields',
      'showLessContactOwnerCustomFields',
      'resetContactOwnerCustomFields',
    ]),
    ...mapTeamMembersActions(['findTeamMembers']),

    ...mapSubAccountsActions(['findSubAccounts']),

    ...mapCustomFieldsActions(['findCustomFieldTypes']),

    ...mapContactsTableActions(['clearContactTableMessage', 'setShouldReloadContactsTable']),

    ...mapContactsSearchActions(['findCampaigns']),

    ...mapEventListActions([
      'getEvents',
      'fetchLastActivityDate',
      'removeEvent',
      'updateEvent',
      'updatePinEvent',
      'showEventsError',
      'clearErrors',
      'activateEvent',
    ]),

    ...mapContactsMutations(['setIsCallingContact', 'setRemovedFromStaticLists']),

    ...mapRecipientsActions(['setToSelected']),

    ...mapContactsTableBulkActions(['bulkCreateEvents', 'resetBulkUpdateContactErrors']),
    ...mapConversationsActions([
      'checkFor10dlcRegister',
      'checkContactsOptInStatuses',
      'checkContactOptInStatus',
      'checkLeadsPlusContact',
    ]),
    ...mapCmaMutations({
      cmaResetErrorMessage: 'resetErrorMessage',
      cmaSetApiKeyError: 'setApiKeyError',
      cmaSetUpdateApiKey: 'setUpdateApiKey',
    }),
    ...mapRelationshipsMutations({
      relClearDeleteMessages: 'clearDeleteMessages',
    }),
    ...mapQualifyActions(['loadContactQualifyStatus', 'getIntegrationStatus']),

    ...mapTemplatesActions({
      templatesClearSuccess: 'clearSuccess',
      templatesClearErrors: 'clearErrors',
    }),
    ...mapSoleProprietorActions(['setShowRegistrationFlowModal', 'setStep']),
    ...mapPaymentActions(['setAddRegisterFeeAddonsSuccess']),
    ...mapPreferencesActions(['updatePreference']),
    ...mapEmailAccountsActions(['getAllowedNewFlow']),
    ...mapEmailSuppressionsActions(['getEmailSuppressions', 'getUnsubscribedStatus']),
    ...mapEmailSuppressionsMutations(['resetSuppressions']),
    ...mapSmsConsentActions(['getConsent']),
    ...mapSmsConsentMutations(['setSubmitSuccess']),
    ...mapUserSmsErrorRatesActions(['getIsUserBlocked']),
    /**
     * Watches for updates $route.params and calls API request on change.
     *
     * This is required to cause a re-render when the user uses the contact search
     * while being on the contact profile page.
     *
     * @param {Function} callback API Request function
     */
    setRouteWatcher(callback) {
      this.$watch('$route.params', params => {
        callback();
      });
    },
    async refreshPage() {
      const contactId = this.$route.params.id;
      await this.findContact({ contactId: this.$route.params.id, profileV2: true });
      await this.loadContactQualifyStatus(this.$route.params.id);
      await this.refreshEvents();
      await this.refreshComments();
      await this.findEmailListsByContact(contactId);
      await this.checkLeadsPlusContact(contactId);
      this.refreshLastActivityDate();
    },

    initActivities() {
      this.refreshLastActivityDate();
    },

    async getActivities() {
      this.pagination.page = this.pagination.page + 1;
      var types = this.selectedTypes.reduce((prev, curr) => [...prev, ...curr.types], []);
      if (types.length !== 0) {
        var allTypes = this.selectedTypes[0].id == eventTypes[0].id;
        await this.getEvents({
          allWebTypes: allTypes,
          types: types,
          pagination: this.pagination,
          isDashboard: false,
          contactId: this.contactIds,
          memberID: this.memberId,
          dateRange: this.dateRange,
          isProfileV2: true,
        });
        this.eventsData = [...this.eventsData, ...this.events];
      } else {
        this.eventsData = [];
      }
    },

    async getComments() {
      this.commentsPagination.page = this.commentsPagination.page + 1;
      await this.getEvents({
        allWebTypes: false,
        types: eventTypes[1].types,
        pagination: this.commentsPagination,
        isDashboard: false,
        contactId: this.contactIds,
        memberID: this.commentsMemberId,
        dateRange: this.commentsDateRange,
        isProfileV2: true,
        isComments: true,
      });
      this.commentsData = [...this.commentsData, ...this.comments];
    },

    async refreshEvents() {
      this.pagination.page = 1;
      var types = this.selectedTypes.reduce((prev, curr) => [...prev, ...curr.types], []);
      if (types.length !== 0) {
        var allTypes = this.selectedTypes[0].id == eventTypes[0].id;
        await this.getEvents({
          allWebTypes: allTypes,
          types: types,
          pagination: this.pagination,
          isDashboard: false,
          contactId: this.contactIds,
          memberID: this.memberId,
          dateRange: this.dateRange,
          isProfileV2: true,
        });
        this.eventsData = [...this.events];
      } else {
        this.eventsData = [];
      }
    },

    async refreshComments() {
      this.commentsPagination.page = 1;
      await this.getEvents({
        allWebTypes: false,
        types: eventTypes[1].types,
        pagination: this.commentsPagination,
        isDashboard: false,
        contactId: this.contactIds,
        memberID: this.commentsMemberId,
        dateRange: this.commentsDateRange,
        isProfileV2: true,
        isComments: true,
      });
      this.commentsData = [...this.comments];
    },

    onTypesChange(types) {
      this.pagination.page = 1;
      this.selectedTypes = types;
      this.refreshEvents();
    },

    onMemberChange(member) {
      this.memberId = member.value;
      this.refreshEvents();
    },

    onDateChange(date) {
      this.dateRange = date.value;
      this.refreshEvents();
    },

    onCommentsMemberChange(member) {
      this.commentsMemberId = member.value;
      this.refreshComments();
    },

    onCommentsDateChange(date) {
      this.commentsDateRange = date.value;
      this.refreshComments();
    },

    async remove(eventId) {
      await this.removeEvent({ eventId });
      this.lastEventIdRemoved = eventId;
      this.eventIsRemoved = true;
      this.refreshEvents();
      this.refreshComments();
      this.refreshLastActivityDate();
    },

    async undoEventRemove(eventId) {
      await this.activateEvent({ eventId });
      this.eventIsRemoved = false;
      this.refreshEvents();
      this.refreshComments();
    },

    async toggleEventPin(activity) {
      this.clearErrors();
      const payload = {
        contact_id: activity.contact_id,
        event_id: activity.id,
        pinned: activity.pinned,
        pinned_event_id: activity.pinnedId,
      };
      await this.updatePinEvent(payload);
      this.eventPinnedWasToggled = true;
      if (!this.eventsError) {
        this.refreshEvents();
        this.refreshComments();
      }
    },

    validateDescription(description) {
      if (description.length > MAX_DESCRIPTION_LENGTH) {
        this.showEventsError(
          `Description should be shorter than ${MAX_DESCRIPTION_LENGTH} characters.`,
        );
        return false;
      }
      return true;
    },
    async showContactChat(contactId) {
      this.selectedTextContactId = contactId;
      await this.checkContactsOptInStatuses([this.selectedTextContactId]);

      this.openSlideDrawer();
      this.smsDrawerRendered = true;
    },
    openEventDrawer(comment = true) {
      this.isComment = comment;
      this.eventToEdit = null;
      this.$refs.eventDrawer.openSlideDrawer();
      this.$refs.eventDrawer.resetDragPosition();
    },
    editEventDrawer(event) {
      this.openEventDrawer(event.type === "Contact Comments");
      this.eventToEdit = event;
    },
    setIsComment(value) {
      this.isComment = value;
    },
    openClearConfirmationDialog() {
      this.clearConfirmationDialog = true;
    },
    changeEmailBoxSize() {
      this.EmailBoxSize = this.EmailBoxSize - 10;
    },
    closeEmailDrawer() {
      const INITIAL_HEIGHT = 95;
      this.EmailBoxSize = INITIAL_HEIGHT;
      this.showEmailSlideDrawer = false;
      this.clearAll();
    },
    resetConfirmSubjectClear() {
      this.confirmSubjectClear = false;
    },
    resetConfirmRecipientClear() {
      this.confirmRecipientClear = false;
    },
    clearAll() {
      this.confirmRecipientClear = true;
      this.confirmSubjectClear = true;
      this.closeClearConfirmationDialog();
      this.emailTemplateToLoad = null;
    },
    closeClearConfirmationDialog() {
      this.clearConfirmationDialog = false;
    },
    showTemplatePicker() {
      this.$refs.emailSubjectBody.showTemplatePicker();
    },
    openEmailDrawer() {
      this.resetConfirmRecipientClear();
      this.resetConfirmSubjectClear();
      this.showEmailSlideDrawer = true;
      this.emailDrawerRendered = true;
    },
    openEmailDrawerPreloadCmaTemplate(event) {
      this.fillEmailDrawer(event);
      this.resetConfirmRecipientClear();
      this.resetConfirmSubjectClear();
      this.showEmailSlideDrawer = true;
      this.emailDrawerRendered = true;
    },
    fillEmailDrawer(event) {
      this.setToSelected([this.contact]);
      const cloudCMADescription = this.parseEventDescription(event.description);
      this.emailTemplateToLoad = {
        subject: EmailReport.subject.replaceAll('{{Address}}', cloudCMADescription.address),
        body: EmailReport.body.replaceAll('{{URLReport}}', cloudCMADescription.documentPDF),
      };
    },
    parseEventDescription(description) {
      return JSON.parse(description.replaceAll(/\&(quot;|#34;)/gi, '"'));
    },
    openEmailFullScreen() {
      this.redirectToFullScreen = true;
      this.$nextTick(() => {
        this.closeSlideDrawer(true, 'email-slide-drawer');
      });
    },
    confirmDrawerClose() {
      this.redirectToFullScreen
        ? this.$router.push('/communications/email')
        : this.closeEmailDrawer();
    },
    async sendMessage(sendOptions) {
      this.$refs.chatContact.callChatHistory(sendOptions);
      this.sendingTextOptionsDialog = false;
      this.resetChat = true;
      this.refreshEvents();
    },
    setFavoriteFields(favoriteFields) {
      this.setFavorites(favoriteFields);
      this.loadFavorites();
    },
    fieldStatusChange(field) {
      const fieldIndex = this.invalidFields.indexOf(field.name);
      if (fieldIndex === -1 && !field.isValid) {
        this.invalidFields.push(field.name);
      } else if (fieldIndex > -1 && field.isValid) {
        this.invalidFields.splice(fieldIndex, 1);
      }
    },
    innerHeightHasChanged() {
      if (!document.querySelector('.profile-container')) return;
      const FOOTER_HEIGHT = document.querySelector('footer').clientHeight;
      const LEFT_BOARD_ACTIONS_HEADER_HEIGHT =
        document.querySelector('.action-header').clientHeight || 0;
      const LEFT_BOARD_PARENT_CONTAINER_HEIGHT =
        document.querySelector('.leftBoardParent').clientHeight || 0;
      let offSetHeight = LEFT_BOARD_PARENT_CONTAINER_HEIGHT - LEFT_BOARD_ACTIONS_HEADER_HEIGHT;
      offSetHeight -= this.userHasChanges && 50; // reduce height to avoid bottom sheet to cover the board
      this.leftBoardHeight = `height: ${offSetHeight}px`;
    },
    async getDraggableCards() {
      const addressFields = this.getAddressFields();
      const optinStatuses = await this.getOptinStatusFields();
      const emailStatuses = await this.getEmailStatusFields();
      this.draggableCards = profileV2Cards(
        this.contact,
        this.assignedUsers,
        this.contact.custom_fields,
        addressFields,
        this.contactTypes,
        this.statuses,
        this.sources,
        this.ownerUsers,
        optinStatuses,
        emailStatuses,
      );

      this.addOwnerCustomFieldsToDraggableCards();
      this.orderDraggableCards();
      this.addSharedWithSubAccountsFieldProfileV2(this.draggableCards);
      this.addSharedWithTeamFieldV2(this.draggableCards);
    },
    deleteAddress(address) {
      this.removeAddress(address);
      this.getDraggableCards();
    },
    addAddress(scrollValue) {
      this.addNewAddress();
      document.getElementById('profileV2SideBoard').scrollTop = scrollValue;
      this.getDraggableCards();
    },
    addCustomField() {
      this.addNewCustomField();
      this.getDraggableCards();
    },
    saveDraggableCardOrder() {
      this.leftBoardCards = this.leftBoardCards.map(card =>
        card.column_position === LEFT_BOARD ? card : { ...card, column_position: LEFT_BOARD },
      );

      this.rightBoardCards = this.rightBoardCards.map(card =>
        card.column_position === RIGTH_BOARD ? card : { ...card, column_position: RIGTH_BOARD },
      );

      const allCardList = this.leftBoardCards.concat(this.rightBoardCards);
      const finalOrder = allCardList.map((card, index) => ({
        order: index,
        column_position: card.column_position,
        card_id: card.card_id,
      }));
      this.cardPreferences = finalOrder;
      this.saveUserPreferences({ key: PreferenceKeys.ContactDraggableCards, value: finalOrder });
    },
    orderDraggableCards() {
      if (this.draggableCards.length && this.cardPreferences.length) {
        if (!this.userHasTextsAccess) {
          this.draggableCards = this.draggableCards.filter(
            card => card.card_id !== 'optin_status',
          );
        } else {
          const hasOptinPreference = this.cardPreferences.find(card => card.card_id === 'optin_status');
          if (!hasOptinPreference) {
            const maxOrderCard = this.cardPreferences.reduce((max, card) => (card.order > max.order ? card : max), this.cardPreferences[0]);
            this.cardPreferences.push({ order: maxOrderCard + 1, column_position: "left", card_id: "optin_status" })
          }
        }
        for (let i = 0; i < this.draggableCards.length; i++) {
          const columnIndex = this.draggableCards.findIndex(item => {
            if (!item.card_id || !this.cardPreferences[i]) return item;
            return item.card_id === this.cardPreferences[i].card_id;
          });
          if (columnIndex > -1) {
            if (!this.draggableCards[columnIndex] || !this.cardPreferences[i]) return
            this.draggableCards[columnIndex].order = this.cardPreferences[i].order;
            this.draggableCards[columnIndex].column_position =
              this.cardPreferences[i].column_position;
          }
        }
      }

      this.draggableCards = this.draggableCards.sort((item, prev) => {
        return item.order - prev.order;
      });

      this.rightBoardCards = this.draggableCards.filter(
        card => card.column_position === RIGTH_BOARD,
      );
      this.leftBoardCards = this.draggableCards.filter(card => card.column_position === LEFT_BOARD);
    },
    showAddCustomFieldDialog() {
      this.customFieldDialog = true;
    },
    getAddressFields() {
      if (this.contact.addresses) {
        return this.contact.addresses.map(fields =>
          profileV2AddressFields(fields, this.addressTypes),
        );
      }
      return [];
    },
    async getOptinStatusFields() {
      const contactId = parseInt(this.$route.params.id, 10);
      
      await this.getConsent(contactId)
      await this.checkContactOptInStatus(contactId);

      if (this.contactOptInStatus === STATUS.denied) {
        return [STATUS_CARD.denied];
      }
      if (this.contactOptInStatus === STATUS.approved) {
        return [STATUS_CARD.approved];
      }
      return [STATUS_CARD.pending];
    },
    async getEmailStatusFields() {
      if (!this.contact.email) {
        this.resetSuppressions();
        return [];
      }

      await this.getEmailSuppressions(this.contact.email);
      await this.getUnsubscribedStatus(this.contact.email);
      return this.suppressions.map(s => EMAIL_STATUS_VALUE[s]).filter(s => !!s);
    },
    async refreshLastActivityDate() {
      await this.fetchLastActivityDate({
        ...eventTypes[0],
        pagination: this.pagination,
        isDashboard: false,
        contactId: this.contactIds,
        memberID: this.memberId,
        dateRange: this.dateRange,
      });
    },
    onContactUpdated() {
      this.refreshEvents();
      this.refreshLastActivityDate();
      this.refreshComments();
    },
    setNewTags(newTags) {
      this.selectedTags = newTags;
    },
    debounceFields(newValue, field) {
      const MAX_DATE_LENGTH = 10;
      const isDateComplete = field.type == 'date' && newValue && newValue.length != MAX_DATE_LENGTH;
      const debounceInput =
        !field.type ||
        isDateComplete ||
        (field.custom && field.type != 'date') ||
        field.type === 'text' ||
        field.type === 'email' ||
        (field.isAddress && field.type != 'type');
      if (debounceInput && !this.userHasChanges) {
        const SECONDS_TO_WAIT = 2000;

        const fieldIndexExists = this.debouncingChanges.findIndex(debounceField => {
          if (field.isAddress) {
            return debounceField.type == field.type && debounceField.id == field.id;
          }
          return debounceField.name == field.name;
        });

        if (fieldIndexExists < 0) {
          this.debouncingChanges.push({ newValue: newValue, ...field });
        } else {
          this.debouncingChanges.splice(fieldIndexExists, 1, { newValue: newValue, ...field });
        }

        debounce(this.prepareDebounceFields, [this.debouncingChanges], SECONDS_TO_WAIT);
      } else {
        this.prepareFieldsValues(newValue, field);
      }
    },
    prepareFieldsValues(newValue, field) {
      if (field.custom) {
        const { id, type, name } = field;
        const customField = { id, value: newValue, name, data_type: type };
        this.addToPatchedFields(customField, 'custom_fields');
      } else {
        if (field.name == 'addresses') newValue.name = field.type;
        this.addToPatchedFields(newValue, field.name);
      }
    },
    prepareDebounceFields(debounceFields) {
      this.debouncingChanges.forEach(field => {
        if (field.type != 'date') this.prepareFieldsValues(field.newValue, field);

        if (field.custom) {
          const customField = this.patchedParams.custom_fields.find(
            custom => custom.id == field.id,
          );
          if (!customField) {
            this.prepareFieldsValues(field.newValue, field);
          }
        } else if (!this.patchedParams[field.name]) {
          this.prepareFieldsValues(field.newValue, field);
        }
      });
      this.debouncingChanges = [];
    },
    changeSendingOption(value) {
      this.sendOptionRadioValue = value;
    },
    changeRecurrenceRuleValid(value) {
      this.recurrenceRuleValid = value;
    },
    userHasAccessOrRedirect() {
      if (this.findContactError) {
        this.$router.push({ name: 'contacts' });
        return;
      }
      this.userHasAccessToContact = true;
    },
    async onSendClick() {
      await this.checkContactsOptInStatuses([this.selectedTextContactId]);

      this.sendingTextOptionsDialog = true;
    },
    onCloseRegisterBrandModal() {
      this.showRegisterBrandModal = false;
      if (this.canSendSMS) {
        this.sendingTextOptionsDialog = true;
      }
    },
    handleContactOwnerCustomFields() {
      this.getDraggableCards();
    },
    loadMoreContactOwnerCustomFields() {
      this.getContactOwnerCustomFields(this.$route.params.id);
    },
    addOwnerCustomFieldsToDraggableCards() {
      if (this.contactOwnerCustomFields.length === 0) return;

      const fields = this.contactOwnerCustomFields.map(item => {
        return {
          id: `${CONTACT_OWNER_CFS_CARD}_${item.id}`,
          name: item.label,
          value: item.value,
          data_type: 'text',
          icon: '',
        };
      });

      const card = {
        column_position: 'left',
        card_title: "Contact Owner's Custom Fields",
        card_action: '',
        card_id: CONTACT_OWNER_CFS_CARD,
        card_component: 'RegularCard',
        order: 3,
        shouldShowMore: this.shouldShowMoreCustomFields,
        shouldShowLess: this.shouldShowLessCustomFields,
        fields,
        contact_owner_name: this.contactOwnerCustomFields[0].owner_full_name,
      };
      this.draggableCards.push(card);
    },
    async refreshContactsRelationships() {
      await this.fetchContactRelationships(this.$route.params.id);
    },
    async onPending10DLCSend() {
      if (!this.registrationStatus10dlc && !this.isLeadsPlusContact) {
        this.setStep(STEPS_SOLE_PROPRIETOR.DECISION);
        this.setShowRegistrationFlowModal({ bool: true, action: solePropCloseAction });
        return;
      }

      if (this.registrationStatus10dlc === REGISTRATION_STATES.CAMPAIGN_COMPLETED) {
        this.sendingOptionsDialog = true;
        return;
      }

      if (this.shouldGoToLeadsPlusFlow && this.isLeadsPlusUser) {
        if (!this.isLeadsPlusContact || this.sendOptionRadioValue !== SEND_OPTIONS.Immediate) {
          this.setStep(STEPS_SOLE_PROPRIETOR.STATUS);
          this.setShowRegistrationFlowModal({ bool: true, action: null });
          return;
        }
        this.onSendClick();
        return;
      }

      if (
        this.registrationStatus10dlc === REGISTRATION_STATES.PAYMENT_PENDING ||
        this.registrationStatus10dlc === REGISTRATION_STATES.PAYMENT_CAMPAIGN_RETRY_PENDING ||
        this.registrationStatus10dlc === REGISTRATION_STATES.PAYMENT_BRAND_RETRY_PENDING
      ) {
        this.setStep(STEPS_SOLE_PROPRIETOR.PAYMENT);
        this.setShowRegistrationFlowModal({ bool: true, action: solePropCloseAction });
        return;
      }

      if (
        this.canSendSMS && (
          this.registrationStatus10dlc === REGISTRATION_STATES.BRAND_SUBMITTED ||
          this.registrationStatus10dlc === REGISTRATION_STATES.PAYMENT_RECEIVED ||
          this.registrationStatus10dlc === REGISTRATION_STATES.CAMPAIGN_SUBMITTED ||
          this.registrationStatus10dlc === REGISTRATION_STATES.CAMPAIGN_PENDING)
      ) {
        return this.onSendClick();
      }

      this.setStep(STEPS_SOLE_PROPRIETOR.STATUS);
      this.setShowRegistrationFlowModal({ bool: true, action: solePropCloseAction });
    },
    shouldHighligthCard(cardId) {
      return this.$route.hash === '#consent' && cardId === 'optin_status';
    }
  },
};
</script>

<style lang="scss" scoped>
.profileWrapper {
  height: calc(100vh - 100px);
  overflow: hidden;
}

.leftBoardParent {
  max-height: 100%;
  width: 100%;
}

.centralBoardHeight {
  height: calc(100vh - 210px);
}

.custom-tab {
  color: #248b9f !important;
  font-weight: bold;
}

@media screen and (width: 2560px),
screen and (width: 1024px) {
  .total-activities {
    margin-left: 2%;
  }
}

@media screen and (width: 1920px) {
  .total-activities {
    margin-left: 0.5%;
  }
}

@media screen and (width: 1440px) {
  .total-activities {
    margin-left: 1%;
  }
}

.total-activities {
  opacity: 0.6;
  font-size: 18px;
  text-align: center;
}

.paginator {
  width: 100px;
  float: right;
}

.activity-scroll {
  width: 100%;
  overflow-y: scroll;
}

.tabs {
  background-color: #f3f5f5;
  border-left: 1px solid black;
  border-right: 1px solid black;
  padding: 0 10px;
  height: 100%;
}

.action {
  color: var(--v-primary-base);
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.44px;
  line-height: 16px;
}

.action-icon {
  cursor: pointer;
}

.no-collapsed {
  width: 25%;
  -webkit-transition: width 1s ease-in-out;
  -moz-transition: width 1s ease-in-out;
  -o-transition: width 1s ease-in-out;
  transition: width 1s ease-in-out;
}

.collapsed {
  position: absolute;
  top: 56px;
  right: 0;
  height: 40px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  cursor: pointer;
  background-color: var(--v-background-lighten5);
}

.slide-drawer {
  position: absolute;
  z-index: 99999;
}

.right {
  transition: 0.5s;
  transform: rotate(0deg);
}

.left {
  transition: 0.5s;
  transform: rotate(180deg);
}

.expanded {
  width: 70%;
}

.section-scroll {
  overflow-y: scroll;
  height: 80vh;
  position: relative;
}

.board {
  background-color: #fafafa;
  padding: 1.5px 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.expand-btn-icon {
  transform: scaleX(-1);
}

.expand-third-row {
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  &--expand {
    padding: 16px;
  }

  &--collapse {
    padding: 24px;
  }
}

.fill-page-height {
  height: 90vh;
}
</style>
